
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/studios/[slug]",
      function () {
        return require("private-next-pages/studios/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/studios/[slug]"])
      });
    }
  